export default "__VITE_ASSET__BLPDJ55F__"